import { IAPIListInterestTagModel } from "../interfaces/IAPIListInterestTagModel";

export class ListInterestTagModel {
  id: string;
  name: string;
  constructor(data?: Partial<ListInterestTagModel>) {
    this.id = data?.id ?? "";
    this.name = data?.name ?? "";
  }

  static deserialize(data: IAPIListInterestTagModel): ListInterestTagModel {
    const mappedData: Partial<ListInterestTagModel> = {
      id: data.id,
      name: data.name,
    };
    return new ListInterestTagModel(mappedData);
  }

  createAPIModel(): IAPIListInterestTagModel { 
    return {
      id: this.id,
      name: this.name,
    };
  }
}
